export default {
  props: {
    show: {
      type: [Number, Boolean],
      required: true
    },
    title: String,
    message: String,
    primaryButtonText: String,
    secondaryButtonText: String,
    invertColors: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCompactUnified() {
      return this.show === 10 && this.message && this.message.includes('<table');
    },
    isUnifiedWarning() {
      return this.show === 10;
    },
    hasKeywordsInBox() {
      if (this.isCompactUnified) return false;
      return this.show === 10;
    },
    dialogSections() {
      const isDialogWithKeywords =
        this.show === 10

      if (!this.message || !isDialogWithKeywords) return null

      const sections = []
      let remainingMessage = this.message

      while (remainingMessage.length > 0) {
        const paragraphStartIndex = remainingMessage.indexOf('<p>')
        if (paragraphStartIndex === -1) break

        const paragraphEndIndex = remainingMessage.indexOf('</p>', paragraphStartIndex)
        if (paragraphEndIndex === -1) break

        const paragraphText = remainingMessage
          .substring(paragraphStartIndex + 3, paragraphEndIndex)
          .trim()

        const nextParagraphStartIndex = remainingMessage.indexOf('<p>', paragraphEndIndex)
        const listStartIndex = remainingMessage.indexOf('<ul>', paragraphEndIndex)

        const hasListBeforeNextParagraph =
          listStartIndex !== -1 &&
          (nextParagraphStartIndex === -1 || listStartIndex < nextParagraphStartIndex)

        if (hasListBeforeNextParagraph) {
          const listEndIndex = remainingMessage.indexOf('</ul>', listStartIndex)

          if (listEndIndex !== -1) {
            const keywordsHtml = remainingMessage
              .substring(listStartIndex + 4, listEndIndex)
              .trim()

            sections.push({ text: paragraphText, keywords: keywordsHtml })
            remainingMessage = remainingMessage.substring(listEndIndex + 5)
          } else {
            sections.push({ text: paragraphText })
            remainingMessage = remainingMessage.substring(paragraphEndIndex + 4)
          }
        } else {
          sections.push({ text: paragraphText })
          remainingMessage = remainingMessage.substring(paragraphEndIndex + 4)
        }
      }
      return sections.length ? sections : null
    },
    introText() {
      if (!this.message) return '';
      if (this.show === 4 || this.show === 5 || this.show === 8 || this.show === 9) return ''
      const parts = this.message.split('<ul>');
      return parts[0] || '';
    },
    keywordsList() {
      if (!this.message) return '';
      if (this.show === 4 || this.show === 5 || this.show === 8 || this.show === 9) return ''
      const ulStartIndex = this.message.indexOf('<ul>');
      const ulEndIndex = this.message.indexOf('</ul>');
      
      if (ulStartIndex === -1 || ulEndIndex === -1) return '';
      
      return this.message.substring(ulStartIndex + 4, ulEndIndex);
    },
    conclusionText() {
      if (!this.message) return '';
      if (this.show === 4 || this.show === 5 || this.show === 8 || this.show === 9) return ''
      const parts = this.message.split('</ul>');
      return parts[1] || '';
    },
    wordsList() {
      if (this.show !== 6 || !this.message) return '';
      
      // Look for the "words found in content" section
      const wordsStartIndex = this.message.indexOf('words_found_in_content');
      if (wordsStartIndex === -1) return '';
      
      // Find the paragraph with the bold words
      const wordsParaStart = this.message.indexOf('<p>', wordsStartIndex);
      const wordsParaEnd = this.message.indexOf('</p>', wordsParaStart + 3);
      
      if (wordsParaStart === -1 || wordsParaEnd === -1) return '';
      
      // Extract the words paragraph content
      const wordsPara = this.message.substring(wordsParaStart + 3, wordsParaEnd);
      
      // Convert comma-separated bold words to list items
      const boldWords = wordsPara.match(/<b>([^<]+)<\/b>/g) || [];
      return boldWords.map(word => `<li>${word}</li>`).join('');
    }
  },
  methods: {
    onPrimaryAction() {
      localStorage.removeItem('savedReports')
      this.$emit('primaryAction')
    },
    onSecondaryAction() {
      this.$emit('secondaryAction')
    }
  }
}
